<template>
    <div>
        <el-form :inline="true" :model="query" class="query-form" size="small">
            <el-form-item>
                <el-button type="primary" icon="el-icon-edit" @click.native="handleForm(null,null)">添加</el-button>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-select v-model="query.roleId" placeholder="请选择角色" @change="onSubmit" clearable>
                    <el-option label="全部角色" value></el-option>
                    <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-input v-model="query.username" placeholder="请输入管理员姓名" prefix-icon="el-icon-search"
                    @keyup.enter.native="onSubmit" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-refresh" @click="onRest"></el-button>
                <el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button>
            </el-form-item>
        </el-form>
        <!-- <el-scrollbar class="table-scrollbar" wrap-style="overflow-x: hidden;"> -->
        <el-table ref="multipleTable" v-loading="loading" :data="list"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}" @selection-change="handleSelectionChange"
            border>
            <el-table-column :selectable="checkSelect" type="selection" width="50" fixed />
            <el-table-column label="编号" prop="id" width="80" align="center" />
            <el-table-column label="姓名" prop="compellation" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="角色" prop="roleName" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="帐号" prop="username" :show-overflow-tooltip="true" align="center" />
            <el-table-column label="添加时间" with="300" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-time"></i>
                    <span>{{ scope.row.createTime | formatDateStr('yyyy-MM-dd hh:mm:ss') }}</span>
                </template>
            </el-table-column>
            <el-table-column label="上次登录时间" with="300" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <i class="el-icon-time" v-if="scope.row.lastLoginTime!=null"></i>
                    <span
                        v-if="scope.row.lastLoginTime!=null">{{ scope.row.lastLoginTime | formatDateStr('yyyy-MM-dd hh:mm:ss') }}</span>
                    <span v-else>暂未登录</span>
                </template>
            </el-table-column>
            <el-table-column label="启用" prop="status" :show-overflow-tooltip="true" align="center">
                <template slot-scope="scope">
                    <el-switch active-color="#13ce66" :disabled="scope.row.roleId!=2?false:true"
                        v-model="scope.row.status==1?true:false" @change="backgroundChange(scope.row)"></el-switch>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                    <el-button type="primary" size="mini" @click.native="handleForm(scope.$index, scope.row)">编辑
                    </el-button>
                    <el-button type="danger" size="mini" :disabled="scope.row.roleId!=2?false:true"
                        @click.native="handleDel(scope.row.id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="left-container">
            <el-button type="danger" size="small" @click="delGroup()">删除已选</el-button>
            <transition name="el-fade-in-linear">
                <el-button size="small" @click="toggleSelection()" v-show="cancelToggle">取消选择</el-button>
            </transition>
        </div>
        <el-pagination class="pagination-container" background :current-page="query.currentPage"
            :page-size="query.pageSize" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            layout="total,sizes,prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50]" :total="totalNumber">
        </el-pagination>

        <!-- 编辑 -->
        <el-dialog :title="formMap[formName]" :visible.sync="formVisible" :before-close="hideForm" width="800px"
            top="5vh" v-dialogDrag>
            <el-form :model="formData" :rules="formRules" ref="dataForm">
                <el-form-item label="管理员账号:" prop="username">
                    <el-input placeholder="填写账号" v-model="formData.username" clearable></el-input>
                </el-form-item>
                <el-form-item label="登录密码:" prop="password">
                    <el-input type="password" placeholder="填写密码" v-model="formData.password" clearable></el-input>
                </el-form-item>
                <el-form-item label="管理员角色:" prop="roleId">
                    <el-select v-model="formData.roleId" placeholder="请选择角色" clearable>
                        <el-option v-for="item in roles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="姓名:" prop="compellation">
                    <el-input placeholder="填写姓名" v-model="formData.compellation" clearable></el-input>
                </el-form-item>
                <div v-if="this.formData.roleId == 1">
                    <el-form-item label="电话:" prop="tel">
                        <el-input placeholder="填写电话" v-model="formData.tel" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="email:" prop="email">
                        <el-input placeholder="填写email" v-model="formData.email" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="Skype:" prop="avatar">
                        <el-input placeholder="填写Skype" v-model="formData.avatar" clearable></el-input>
                    </el-form-item>
                </div>
            </el-form>

            <div slot="footer" class="dialog-footer">
                <el-button @click.native="hideForm">取消</el-button>
                <el-button type="primary" @click.native="formSubmit" :loading="formLoading">提交</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import {
        authAdminList,
        authAdminRoleList,
        authAdminSave,
        authAdminDelete,
        authAdminChange
    } from "../../../api/auth/authAdmin";
    const formJson = {
        id: "",
        password: "",
        username: "",
        compellation: "",
        roleId: "",
        tel: "",
        email: "",
        avatar: "",
        status: 1,
        roles: []
    };
    export default {
        data() {
            let validatePass = (rule, value, callback) => {
                if (value === "") {
                    callback(new Error("请输入密码"));
                } else {
                    callback();
                }
            };
            return {
                query: {
                    username: "",
                    status: "",
                    currentPage: 1,
                    pageSize: 10,
                    roleId: ""
                },
                roles: [],
                list: [],
                totalNumber: 0,
                loading: true,
                index: null,
                formName: null,
                formMap: {
                    add: "添加",
                    edit: "编辑"
                },
                cancelToggle: false,
                formLoading: false,
                formVisible: false,
                formInput: false,
                formData: formJson,
                formAdd: formJson,
                formRules: {},
                addRules: {
                    username: [{
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }],
                    password: [{
                            required: true,
                            message: "请输入密码",
                            trigger: "blur"
                        },
                        {
                            validator: validatePass,
                            trigger: "blur"
                        }
                    ],
                    roleId: [{
                        required: true,
                        message: "请选择角色",
                        trigger: "blur"
                    }],
                    compellation: [{
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    }],
                    tel: {
                        required: true,
                        message: "请输入电话",
                        trigger: "blur"
                    },
                    email: {
                        required: true,
                        message: "请输入邮箱",
                        trigger: "blur"
                    },
                    avatar: {
                        required: true,
                        message: "请输入Skype",
                        trigger: "blur"
                    }
                },
                editRules: {
                    username: [{
                        required: true,
                        message: "请输入用户名",
                        trigger: "blur"
                    }],
                    password: [{
                            required: true,
                            message: "请输入密码",
                            trigger: "blur"
                        },
                        {
                            validator: validatePass,
                            trigger: "blur"
                        }
                    ],
                    roleId: [{
                        required: true,
                        message: "请选择角色",
                        trigger: "blur"
                    }],
                    compellation: [{
                        required: true,
                        message: "请输入姓名",
                        trigger: "blur"
                    }],
                    tel: {
                        required: true,
                        message: "请输入电话",
                        trigger: "blur"
                    },
                    email: {
                        required: true,
                        message: "请输入邮箱",
                        trigger: "blur"
                    },
                    avatar: {
                        required: true,
                        message: "请输入Skype",
                        trigger: "blur"
                    }
                },
                multipleSelection: [] //多选集合
            };
        },
        methods: {
            checkSelect(row, index) {
                let isChecked = true;
                if (row.roleId != 2) { // 判断里面是否存在某个参数
                    isChecked = true
                } else {
                    isChecked = false
                }
                return isChecked
            },
            // 启用
            backgroundChange(row) {
                let data = {
                    avatar: row.avatar,
                    compellation: row.compellation,
                    createTime: row.createTime,
                    email: row.email,
                    id: row.id,
                    lastLoginIp: row.lastLoginIp,
                    lastLoginTime: row.lastLoginTime,
                    password: row.password,
                    roleId: row.roleId,
                    roleName: row.roleName,
                    sex: row.sex,
                    status: row.status == 1 ? 0 : 1,
                    tel: row.tel,
                    username: row.username,
                    usertype: row.usertype
                }
                authAdminChange(data).then(response => {
                    if (response.code) {
                        this.$message.error(response.message);
                        return false;
                    }
                    this.$message.success("操作成功");
                    this.getList();
                });
            },
            toggleSelection(rows) {
                if (rows) {
                    rows.forEach(row => {
                        this.$refs.multipleTable.toggleRowSelection(row);
                    });
                } else {
                    this.$refs.multipleTable.clearSelection();
                }
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
                if (val == "") {
                    this.cancelToggle = false;
                    return;
                }
                this.cancelToggle = true;
            },
            delGroup() {
                var ids = this.multipleSelection.map(item => item.id).join(); //获取所有选中行的id组成的字符串，以逗号分隔
                if (ids == "") {
                    this.$message({
                        message: "请先选择",
                        type: "warning"
                    });
                    return;
                }
                this.handleDel(ids);
            },
            onRest() {
                this.query = {
                    username: "",
                    status: "",
                    currentPage: 1,
                    pageSize: 10,
                    roleId: ""
                };
                this.getList();
            },
            onSubmit() {
                this.query.currentPage = 1;
                this.$router.push({
                    path: ""
                    //query: this.query
                });
                this.getList();
            },
            handleCurrentChange(val) {
                this.query.currentPage = val;
                //scrollTo(0, 800);
                this.getList();
            },
            handleSizeChange(val) {
                this.query.pageSize = val;
                this.getList();
            },
            getList() {
                this.loading = true;
                authAdminList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                        }
                        this.list = response.data.list || [];

                        this.totalNumber = response.data.totalNumber || 0;
                        setTimeout(() => {
                            this.loading = false;
                        }, 0.3 * 1000);
                    })
                    .catch(() => {
                        this.loading = false;
                        this.list = [];
                        this.totalNumber = 0;
                        this.roles = [];
                    });
            },
            getRoleList() {
                authAdminRoleList(this.query)
                    .then(response => {
                        if (response.code) {
                            this.$message.error(response.message);
                            return false;
                        }
                        this.roles = response.data.list || [];
                    })
                    .catch(() => {});
            },
            // 隐藏表单
            hideForm() {
                // 更改值
                this.formVisible = !this.formVisible;
                // 清空表单
                this.$refs["dataForm"].resetFields();
                this.formData.username = "";
                this.formData.password = "";
                return true;
            },
            // 显示表单
            handleForm(index, row) {
                this.formVisible = true;
                this.formData = Object.assign({}, formJson);
                if (row !== null) {
                    this.formData = Object.assign({}, row);
                }
                // this.formData.password = "";
                this.formName = "add";
                this.formData.checkPassword = "";
                this.formRules = this.addRules;
                //编辑
                if (index !== null) {
                    this.index = index;
                    this.formName = "edit";
                    this.formRules = this.editRules;
                }
                // 清空验证信息表单
                if (this.$refs["dataForm"]) {
                    this.$refs["dataForm"].clearValidate();
                }
            },
            formSubmit() {
                this.$refs["dataForm"].validate(valid => {
                    if (valid) {
                        this.formLoading = true;
                        let data = Object.assign({}, this.formData);
                        authAdminSave(data, this.formName).then(response => {
                            this.formLoading = false;
                            if (response.code) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            // 刷新表单
                            this.$refs["dataForm"].resetFields();
                            this.formVisible = false;
                            this.getList();
                        });
                    }
                });
            },
            // 删除
            handleDel(ids) {
                if (ids) {
                    this.$confirm("确认要删除吗?", "提示", {
                            type: "warning"
                        })
                        .then(() => {
                            this.loading = true;
                            let para = {
                                ids: ids
                            };
                            authAdminDelete(para)
                                .then(response => {
                                    this.loading = false;
                                    if (response.code) {
                                        this.$message.error(response.message);
                                        return false;
                                    }
                                    this.$message.success("删除成功");
                                    // 刷新数据
                                    //this.list.splice(index, 1);
                                    this.getList();
                                })
                                .catch(() => {
                                    this.loading = false;
                                });
                        })
                        .catch(() => {});
                }
            }
        },
        filters: {
            statusFilterType(status) {
                const statusMap = {
                    0: "gray",
                    1: "success",
                    2: "danger"
                };
                return statusMap[status];
            },
            statusFilterName(status) {
                const statusMap = {
                    0: "禁用",
                    1: "正常",
                    2: "未验证"
                };
                return statusMap[status];
            }
        },
        mounted() {},
        created() {
            // 将参数拷贝进查询对象
            let query = this.$route.query;
            this.query = Object.assign(this.query, query);
            this.query.pageSize = parseInt(this.query.pageSize);
            // 加载表格数据
            this.getList();
            // 加载角色列表
            this.getRoleList();
        }
    };

</script>

<style>
    body {
        margin: 0;
    }

</style>
